var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isLoggedIn
    ? _c(
        "b-container",
        {
          directives: [
            {
              name: "animate-css",
              rawName: "v-animate-css",
              value: "fadeIn",
              expression: "'fadeIn'"
            }
          ],
          staticClass: "dashboard px-4 px-lg-4 px-md-5 px-sm-5 px-0",
          attrs: { fluid: "" }
        },
        [
          _c("img", {
            staticClass: "img-logo-other mb-5 d-none d-lg-block d-xl-block",
            attrs: { src: "/public/images/icons/icon-other-grey.png" }
          }),
          _c(
            "div",
            {
              staticClass: "d-none d-lg-flex d-xl-flex justify-content-between"
            },
            [_c("h1", [_vm._v(_vm._s(_vm.$route.meta.title))])]
          ),
          _c("div", { staticClass: "mt-4" }, [
            _c("h3", { staticClass: "mb-3 fs-24" }, [
              _vm._v(_vm._s(_vm.$route.meta.subtitle))
            ])
          ]),
          _c(
            "div",
            { staticClass: "dashContent" },
            [
              _c(
                "b-row",
                { staticClass: "dashRow firstDash" },
                [
                  _vm.VReligible
                    ? _c("b-col", { attrs: { md: "12" } }, [
                        _c(
                          "div",
                          { staticClass: "mainCard" },
                          [
                            _c(
                              "b-card",
                              {
                                attrs: {
                                  "img-src": "/public/images/reg_VR.jpg",
                                  "img-alt": "Virtual Challenge Registration",
                                  "img-top": ""
                                }
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "statusContainer" },
                                  [
                                    !_vm.virtualTransactionData &&
                                    !_vm.virtualEventClosed
                                      ? _c(
                                          "div",
                                          { staticClass: "statusIdle" },
                                          [
                                            _c("h2", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("status.VRidle.head")
                                                )
                                              )
                                            ]),
                                            _c("b-card-text", [
                                              _vm._v(
                                                "\n\t\t\t\t\t\t\t\t" +
                                                  _vm._s(
                                                    _vm.$t("status.VRidle.desc")
                                                  ) +
                                                  "\n\t\t\t\t\t\t\t\t"
                                              )
                                            ]),
                                            _c("b-row", {
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.$t("status.VRidle.step")
                                                )
                                              }
                                            }),
                                            _c(
                                              "div",
                                              { staticClass: "clearfix" },
                                              [_vm._v(" ")]
                                            ),
                                            _c(
                                              "b-button",
                                              {
                                                directives: [
                                                  {
                                                    name: "b-modal",
                                                    rawName:
                                                      "v-b-modal.registrationModal",
                                                    modifiers: {
                                                      registrationModal: true
                                                    }
                                                  }
                                                ],
                                                attrs: {
                                                  block: "",
                                                  variant: "primary"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    _vm.channel = "VIRTUAL"
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("status.VRidle.btn")
                                                  )
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _c("registration-modal", {
                                      attrs: { "modal-data": _vm.channel }
                                    }),
                                    _vm.virtualEventClosed &&
                                    !_vm.virtualTransactionData
                                      ? _c(
                                          "div",
                                          { staticClass: "statusVRclosed" },
                                          [
                                            _c("h2", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("status.VRclosed.head")
                                                )
                                              )
                                            ]),
                                            _c(
                                              "b-row",
                                              { staticClass: "status" },
                                              [
                                                _c(
                                                  "b-col",
                                                  { attrs: { sm: "auto" } },
                                                  [
                                                    _c("svg-image", {
                                                      attrs: {
                                                        image: "statusClosed"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _c("b-col", [
                                                  _c("h6", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "status.VRclosed.label"
                                                        )
                                                      )
                                                    )
                                                  ]),
                                                  _c("p", {
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        _vm.$t(
                                                          "status.VRclosed.desc"
                                                        )
                                                      )
                                                    }
                                                  })
                                                ])
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    !_vm.VRactivated &&
                                    _vm.virtualTransactionData &&
                                    _vm.virtualTransactionData.data
                                      .trnsConfirmed == "1"
                                      ? _c(
                                          "div",
                                          { staticClass: "statusVRconnect" },
                                          [
                                            _c("h2", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "status.VRconnect.head"
                                                  )
                                                )
                                              )
                                            ]),
                                            _c(
                                              "b-row",
                                              { staticClass: "status" },
                                              [
                                                _c(
                                                  "b-col",
                                                  { attrs: { sm: "auto" } },
                                                  [
                                                    _c("svg-image", {
                                                      attrs: {
                                                        image: "statusConnect"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "b-col",
                                                  [
                                                    _c("h6", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "status.VRconnect.label"
                                                          )
                                                        )
                                                      )
                                                    ]),
                                                    _c(
                                                      "i18n",
                                                      {
                                                        attrs: {
                                                          path:
                                                            "status.VRconnect.desc",
                                                          tag: "p"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            attrs: {
                                                              place: "timelimit"
                                                            }
                                                          },
                                                          [
                                                            _c("strong", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm._f(
                                                                    "moment"
                                                                  )(
                                                                    _vm
                                                                      .virtualTransactionData
                                                                      .data
                                                                      .trnsExpiredTime,
                                                                    "D MMMM YYYY HH:mm"
                                                                  )
                                                                ) +
                                                                  " WIB (GMT+7)"
                                                              )
                                                            ])
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "connectGroup" },
                                              [
                                                _c("b-button", {
                                                  staticClass:
                                                    "btn-connect fit",
                                                  attrs: {
                                                    href:
                                                      "https://fitsync.borobudurmarathon.com/google/auth/" +
                                                      _vm.userProfile.memberId
                                                  },
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      _vm.$t(
                                                        "register.form.virtual.connect.fit"
                                                      )
                                                    )
                                                  }
                                                }),
                                                _c("b-button", {
                                                  staticClass:
                                                    "btn-connect endo",
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      _vm.$t(
                                                        "register.form.virtual.connect.endo"
                                                      )
                                                    )
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.toggleConnectModal(
                                                        "endo"
                                                      )
                                                    }
                                                  }
                                                }),
                                                _c("b-button", {
                                                  staticClass:
                                                    "btn-connect garmin",
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      _vm.$t(
                                                        "register.form.virtual.connect.garmin"
                                                      )
                                                    )
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.toggleConnectModal(
                                                        "garmin"
                                                      )
                                                    }
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm.VRactivated &&
                                    _vm.virtualTransactionData &&
                                    _vm.virtualTransactionData.data
                                      .trnsConfirmed == "1"
                                      ? _c(
                                          "div",
                                          { staticClass: "statusVRactivated" },
                                          [
                                            _c("h2", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "status.VRactivated.head"
                                                  )
                                                )
                                              )
                                            ]),
                                            _c(
                                              "b-row",
                                              { staticClass: "status" },
                                              [
                                                _c(
                                                  "b-col",
                                                  { attrs: { sm: "auto" } },
                                                  [
                                                    _c("svg-image", {
                                                      attrs: {
                                                        image: "statusWait"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _c("b-col", [
                                                  _c("h6", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "status.VRactivated.label"
                                                        )
                                                      )
                                                    )
                                                  ]),
                                                  _c("p", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "status.VRactivated.desc"
                                                        )
                                                      )
                                                    )
                                                  ])
                                                ])
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm.virtualTransactionData &&
                                    _vm.virtualTransactionData.data
                                      .trnsConfirmed == "1" &&
                                    _vm.submissionPeriodOpen
                                      ? _c(
                                          "div",
                                          { staticClass: "statusVRrunning" },
                                          [
                                            _c("h2", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "status.VRrunning.head"
                                                  )
                                                )
                                              )
                                            ]),
                                            _c(
                                              "b-row",
                                              { staticClass: "status" },
                                              [
                                                _c(
                                                  "b-col",
                                                  { attrs: { sm: "auto" } },
                                                  [
                                                    _c("svg-image", {
                                                      attrs: {
                                                        image: "statusSuccess"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _c("b-col", [
                                                  _c("h6", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "status.VRrunning.label"
                                                        )
                                                      )
                                                    )
                                                  ]),
                                                  _c("p", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "status.VRrunning.desc"
                                                        )
                                                      )
                                                    )
                                                  ])
                                                ])
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm.virtualTransactionData &&
                                    _vm.virtualTransactionData.data
                                      .trnsConfirmed == "1" &&
                                    _vm.VRSubmitted
                                      ? _c(
                                          "div",
                                          { staticClass: "statusVRcomplete" },
                                          [
                                            _c("h2", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "status.VRcomplete.head"
                                                  )
                                                )
                                              )
                                            ]),
                                            _c(
                                              "b-row",
                                              { staticClass: "status" },
                                              [
                                                _c(
                                                  "b-col",
                                                  { attrs: { sm: "auto" } },
                                                  [
                                                    _c("svg-image", {
                                                      attrs: {
                                                        image: "statusSuccess"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _c("b-col", [
                                                  _c("h6", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "status.VRcomplete.label"
                                                        )
                                                      )
                                                    )
                                                  ]),
                                                  _c("p", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "status.VRcomplete.desc"
                                                        )
                                                      )
                                                    )
                                                  ])
                                                ])
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm.virtualTransactionData &&
                                    _vm.virtualTransactionData.data
                                      .trnsConfirmed == "1" &&
                                    _vm.VRMissed
                                      ? _c(
                                          "div",
                                          { staticClass: "statusVRmissed" },
                                          [
                                            _c("h2", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("status.VRmissed.head")
                                                )
                                              )
                                            ]),
                                            _c(
                                              "b-row",
                                              { staticClass: "status" },
                                              [
                                                _c(
                                                  "b-col",
                                                  { attrs: { sm: "auto" } },
                                                  [
                                                    _c("svg-image", {
                                                      attrs: {
                                                        image: "statusClosed"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _c("b-col", [
                                                  _c("h6", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "status.VRmissed.label"
                                                        )
                                                      )
                                                    )
                                                  ]),
                                                  _c("p", {
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        _vm.$t(
                                                          "status.VRmissed.desc"
                                                        )
                                                      )
                                                    }
                                                  })
                                                ])
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                ),
                                _c("connect-modal", {
                                  attrs: {
                                    showConnectModal: _vm.showConnectModal,
                                    targetConnectModal: _vm.targetConnectModal
                                  }
                                }),
                                _vm.VRactivated &&
                                _vm.virtualTransactionData &&
                                _vm.virtualTransactionData.data.trnsConfirmed ==
                                  "1"
                                  ? _c(
                                      "div",
                                      { staticClass: "VRdata" },
                                      [
                                        _c(
                                          "b-row",
                                          [
                                            _c(
                                              "b-col",
                                              {
                                                staticClass: "regCategory",
                                                attrs: { sm: "4" }
                                              },
                                              [
                                                _vm.virtualTransactionData
                                                  .linked.evrlTrnsId[0]
                                                  .evpaEvncId == "775"
                                                  ? _c(
                                                      "div",
                                                      { staticClass: "M" },
                                                      [
                                                        _c("img", {
                                                          attrs: {
                                                            src:
                                                              "/public/images/patch_M.png"
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm.virtualTransactionData
                                                  .linked.evrlTrnsId[0]
                                                  .evpaEvncId == "776"
                                                  ? _c(
                                                      "div",
                                                      { staticClass: "HM" },
                                                      [
                                                        _c("img", {
                                                          attrs: {
                                                            src:
                                                              "/public/images/patch_HM.png"
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm.virtualTransactionData
                                                  .linked.evrlTrnsId[0]
                                                  .evpaEvncId == "777"
                                                  ? _c(
                                                      "div",
                                                      { staticClass: "10K" },
                                                      [
                                                        _c("img", {
                                                          attrs: {
                                                            src:
                                                              "/public/images/patch_10K.png"
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm.virtualTransactionData
                                                  .linked.evrlTrnsId[0]
                                                  .evpaEvncId == "778"
                                                  ? _c(
                                                      "div",
                                                      { staticClass: "FR" },
                                                      [
                                                        _c("img", {
                                                          attrs: {
                                                            src:
                                                              "/public/images/patch_FR.png"
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _c(
                                                  "div",
                                                  { staticClass: "regID" },
                                                  [
                                                    _c(
                                                      "p",
                                                      { staticClass: "sub" },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "register.form.virtual.data.reg"
                                                            )
                                                          )
                                                        )
                                                      ]
                                                    ),
                                                    _c(
                                                      "p",
                                                      { staticClass: "ID" },
                                                      [
                                                        _c("strong", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm
                                                                .virtualTransactionData
                                                                .data.trnsRefId
                                                            )
                                                          )
                                                        ])
                                                      ]
                                                    ),
                                                    _c(
                                                      "p",
                                                      { staticClass: "date" },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f("moment")(
                                                              _vm
                                                                .virtualTransactionData
                                                                .data
                                                                .trnsConfirmTime,
                                                              "D MMMM YYYY - hh:mm"
                                                            )
                                                          ) + " WIB (GMT+7)"
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _c("b-col", [
                                              _vm.connectionPeriodOpen
                                                ? _c("div", [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "groupLabel"
                                                      },
                                                      [
                                                        _c("label", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "register.form.virtual.data.app"
                                                              )
                                                            )
                                                          )
                                                        ])
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      { staticClass: "VRapp" },
                                                      _vm._l(
                                                        _vm.trackerChannels,
                                                        function(
                                                          trackerChannel,
                                                          trackerName
                                                        ) {
                                                          return _c(
                                                            "b-row",
                                                            {
                                                              key: trackerName,
                                                              class: trackerName
                                                            },
                                                            [
                                                              _c(
                                                                "b-col",
                                                                {
                                                                  attrs: {
                                                                    sm: "8"
                                                                  }
                                                                },
                                                                [
                                                                  trackerName ==
                                                                  "fit"
                                                                    ? _c("p", [
                                                                        _c(
                                                                          "img",
                                                                          {
                                                                            attrs: {
                                                                              src:
                                                                                "/public/images/app/fit.png"
                                                                            }
                                                                          }
                                                                        ),
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              trackerChannel.account
                                                                            )
                                                                        )
                                                                      ])
                                                                    : _vm._e(),
                                                                  trackerName ==
                                                                  "endomondo"
                                                                    ? _c("p", [
                                                                        _c(
                                                                          "img",
                                                                          {
                                                                            attrs: {
                                                                              src:
                                                                                "/public/images/app/endomondo.png"
                                                                            }
                                                                          }
                                                                        ),
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              trackerChannel.account
                                                                            )
                                                                        )
                                                                      ])
                                                                    : _vm._e(),
                                                                  trackerName ==
                                                                  "garmin"
                                                                    ? _c("p", [
                                                                        _c(
                                                                          "img",
                                                                          {
                                                                            attrs: {
                                                                              src:
                                                                                "/public/images/app/garmin.png"
                                                                            }
                                                                          }
                                                                        ),
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              trackerChannel.account
                                                                            )
                                                                        )
                                                                      ])
                                                                    : _vm._e()
                                                                ]
                                                              ),
                                                              _c(
                                                                "b-col",
                                                                {
                                                                  attrs: {
                                                                    sm: "4"
                                                                  }
                                                                },
                                                                [
                                                                  trackerChannel.connected
                                                                    ? _c(
                                                                        "b-button",
                                                                        {
                                                                          staticClass:
                                                                            "btn-disconnect",
                                                                          attrs: {
                                                                            block:
                                                                              ""
                                                                          },
                                                                          on: {
                                                                            click: function(
                                                                              $event
                                                                            ) {
                                                                              return _vm.disconnectTracker(
                                                                                trackerChannel
                                                                              )
                                                                            }
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm.$t(
                                                                                "register.form.virtual.auth.disconnect"
                                                                              )
                                                                            )
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                  !trackerChannel.connected &&
                                                                  trackerName ==
                                                                    "fit"
                                                                    ? _c(
                                                                        "b-button",
                                                                        {
                                                                          staticClass:
                                                                            "btn-disconnect",
                                                                          attrs: {
                                                                            block:
                                                                              "",
                                                                            href:
                                                                              "https://fitsync.borobudurmarathon.com/google/auth/" +
                                                                              _vm
                                                                                .userProfile
                                                                                .memberId
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm.$t(
                                                                                "register.form.virtual.auth.connect"
                                                                              )
                                                                            )
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                  !trackerChannel.connected &&
                                                                  trackerName ==
                                                                    "endomondo"
                                                                    ? _c(
                                                                        "b-button",
                                                                        {
                                                                          staticClass:
                                                                            "btn-disconnect",
                                                                          attrs: {
                                                                            block:
                                                                              ""
                                                                          },
                                                                          on: {
                                                                            click: function(
                                                                              $event
                                                                            ) {
                                                                              return _vm.toggleConnectModal(
                                                                                "endo"
                                                                              )
                                                                            }
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm.$t(
                                                                                "register.form.virtual.auth.connect"
                                                                              )
                                                                            )
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                  !trackerChannel.connected &&
                                                                  trackerName ==
                                                                    "garmin"
                                                                    ? _c(
                                                                        "b-button",
                                                                        {
                                                                          staticClass:
                                                                            "btn-disconnect",
                                                                          attrs: {
                                                                            block:
                                                                              ""
                                                                          },
                                                                          on: {
                                                                            click: function(
                                                                              $event
                                                                            ) {
                                                                              return _vm.toggleConnectModal(
                                                                                "garmin"
                                                                              )
                                                                            }
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm.$t(
                                                                                "register.form.virtual.auth.connect"
                                                                              )
                                                                            )
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e()
                                                                ],
                                                                1
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        }
                                                      ),
                                                      1
                                                    )
                                                  ])
                                                : _vm._e(),
                                              _vm.patchShipped
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "deliveryStatus"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "groupLabel"
                                                        },
                                                        [
                                                          _c("label", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "register.form.virtual.data.shipping"
                                                                )
                                                              )
                                                            )
                                                          ])
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "VRdelivery"
                                                        },
                                                        [
                                                          _c(
                                                            "b-row",
                                                            [
                                                              _c(
                                                                "b-col",
                                                                {
                                                                  attrs: {
                                                                    md: "auto"
                                                                  }
                                                                },
                                                                [
                                                                  _c("img", {
                                                                    staticStyle: {
                                                                      width:
                                                                        "40px"
                                                                    },
                                                                    attrs: {
                                                                      src:
                                                                        "/public/images/jne.png"
                                                                    }
                                                                  })
                                                                ]
                                                              ),
                                                              _c(
                                                                "b-col",
                                                                {
                                                                  attrs: {
                                                                    md: "auto"
                                                                  }
                                                                },
                                                                [
                                                                  _c("p", [
                                                                    _c(
                                                                      "strong",
                                                                      [
                                                                        _vm._v(
                                                                          "CGK2H03789568816"
                                                                        )
                                                                      ]
                                                                    )
                                                                  ])
                                                                ]
                                                              )
                                                            ],
                                                            1
                                                          ),
                                                          _c("p", [
                                                            _vm._v(
                                                              "SHIPMENT RECEIVED BY JNE COUNTER OFFICER AT [JAKARTA]"
                                                            )
                                                          ])
                                                        ],
                                                        1
                                                      )
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _c(
                                                "div",
                                                { staticClass: "groupLabel" },
                                                [
                                                  _c("label", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "register.form.virtual.data.address"
                                                        )
                                                      )
                                                    )
                                                  ])
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                { staticClass: "VRaddress" },
                                                [
                                                  _c("p", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm
                                                          .virtualTransactionData
                                                          .linked.evrlTrnsId[0]
                                                          .evpaDeliveryAddress
                                                      )
                                                    )
                                                  ]),
                                                  _c("p", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.deliveryLocation
                                                      )
                                                    )
                                                  ]),
                                                  _c("p", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.countryObject[
                                                          _vm
                                                            .virtualTransactionData
                                                            .linked
                                                            .evrlTrnsId[0]
                                                            .evpaCountry
                                                        ]
                                                      )
                                                    )
                                                  ]),
                                                  _c("p", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm
                                                          .virtualTransactionData
                                                          .linked.evrlTrnsId[0]
                                                          .evpaPostCode
                                                      )
                                                    )
                                                  ]),
                                                  _c("p", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm
                                                          .virtualTransactionData
                                                          .linked.evrlTrnsId[0]
                                                          .evpaDeliveryPhone
                                                      )
                                                    )
                                                  ])
                                                ]
                                              )
                                            ])
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ])
                    : _vm._e(),
                  !_vm.VReligible && _vm.invited
                    ? _c(
                        "b-col",
                        {
                          class: {
                            dashDisabled: _vm.ballotStatus.confirmedViaSaveDuit
                          },
                          attrs: { md: "8" }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "mainCard" },
                            [
                              _c(
                                "b-card",
                                {
                                  attrs: {
                                    "img-src": "/public/images/reg.jpg",
                                    "img-alt": "Registration",
                                    "img-top": ""
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "statusContainer" },
                                    [
                                      _vm.ballotStatus.readyToRegister
                                        ? _c(
                                            "div",
                                            { staticClass: "statusIdle" },
                                            [
                                              _c("h2", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("status.idle.head")
                                                  )
                                                )
                                              ]),
                                              _c(
                                                "b-form",
                                                {
                                                  on: { submit: _vm.onSubmit }
                                                },
                                                [
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      attrs: {
                                                        id: "",
                                                        label: _vm.$t(
                                                          "status.idle.label"
                                                        ),
                                                        "label-for": "",
                                                        description: _vm.$t(
                                                          "status.idle.desc"
                                                        )
                                                      }
                                                    },
                                                    [
                                                      _c("b-form-select", {
                                                        attrs: {
                                                          options:
                                                            _vm.regChannel,
                                                          disabled:
                                                            _vm.ballotStatus
                                                              .confirmedViaSaveDuit
                                                        },
                                                        model: {
                                                          value: _vm.channel,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.channel = $$v
                                                          },
                                                          expression: "channel"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  !_vm.invited
                                                    ? _c(
                                                        "b-button",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "b-modal",
                                                              rawName:
                                                                "v-b-modal.registrationModal",
                                                              modifiers: {
                                                                registrationModal: true
                                                              }
                                                            }
                                                          ],
                                                          attrs: {
                                                            variant: "primary",
                                                            disabled:
                                                              _vm.channel ==
                                                              null
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "AAA" +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "status.idle.btn"
                                                                )
                                                              )
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _c("registration-modal", {
                                        attrs: { "modal-data": _vm.channel }
                                      }),
                                      _vm.ballotStatus.waiting
                                        ? _c(
                                            "div",
                                            { staticClass: "statusWait" },
                                            [
                                              _c("h2", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("status.wait.head")
                                                  )
                                                )
                                              ]),
                                              _c(
                                                "b-row",
                                                { staticClass: "status" },
                                                [
                                                  _c(
                                                    "b-col",
                                                    { attrs: { sm: "auto" } },
                                                    [
                                                      _c("svg-image", {
                                                        attrs: {
                                                          image: "statusWait"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _c("b-col", [
                                                    _c("h6", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "status.wait.label"
                                                          )
                                                        )
                                                      )
                                                    ]),
                                                    _c("p", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "status.wait.desc"
                                                          )
                                                        )
                                                      )
                                                    ])
                                                  ])
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm.ballotStatus.eliteSelection
                                        ? _c(
                                            "div",
                                            { staticClass: "statusWait" },
                                            [
                                              _c("h2", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "status.eliteSelection.head"
                                                    )
                                                  )
                                                )
                                              ]),
                                              _c(
                                                "b-row",
                                                { staticClass: "status" },
                                                [
                                                  _c(
                                                    "b-col",
                                                    { attrs: { sm: "auto" } },
                                                    [
                                                      _c("svg-image", {
                                                        attrs: {
                                                          image: "statusWait"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _c("b-col", [
                                                    _c("h6", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "status.eliteSelection.label"
                                                          )
                                                        )
                                                      )
                                                    ]),
                                                    _c("p", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "status.eliteSelection.desc"
                                                          )
                                                        )
                                                      )
                                                    ])
                                                  ])
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm.ballotStatus.frqWaiting &&
                                      !_vm.ballotStatus.approved &&
                                      _vm.userProfile.fastRunnerInfo
                                        .mmfrStatus == 0
                                        ? _c(
                                            "div",
                                            { staticClass: "statusFRQWait" },
                                            [
                                              _c("h2", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "status.FRQwait.head"
                                                    )
                                                  )
                                                )
                                              ]),
                                              _c(
                                                "b-row",
                                                { staticClass: "status" },
                                                [
                                                  _c(
                                                    "b-col",
                                                    { attrs: { sm: "auto" } },
                                                    [
                                                      _c("svg-image", {
                                                        attrs: {
                                                          image: "statusWait"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _c("b-col", [
                                                    _c("h6", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "status.FRQwait.label"
                                                          )
                                                        )
                                                      )
                                                    ]),
                                                    _c("p", {
                                                      domProps: {
                                                        innerHTML: _vm._s(
                                                          _vm.$t(
                                                            "status.FRQwait.desc"
                                                          )
                                                        )
                                                      }
                                                    })
                                                  ])
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm.userProfile.fastRunnerInfo &&
                                      _vm.userProfile.fastRunnerInfo
                                        .mmfrStatus == 2
                                        ? _c(
                                            "div",
                                            { staticClass: "statusSwitched" },
                                            [
                                              _c("h2", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "status.switched.head"
                                                    )
                                                  )
                                                )
                                              ]),
                                              _c(
                                                "b-row",
                                                { staticClass: "status" },
                                                [
                                                  _c(
                                                    "b-col",
                                                    { attrs: { sm: "auto" } },
                                                    [
                                                      _c("svg-image", {
                                                        attrs: {
                                                          image:
                                                            "statusSwitched"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _c("b-col", [
                                                    _c("h6", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "status.switched.label"
                                                          )
                                                        )
                                                      )
                                                    ]),
                                                    _c("p", {
                                                      domProps: {
                                                        innerHTML: _vm._s(
                                                          _vm.$t(
                                                            "status.switched.desc"
                                                          )
                                                        )
                                                      }
                                                    })
                                                  ])
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm.ballotStatus.drawing
                                        ? _c(
                                            "div",
                                            { staticClass: "statusDrawing" },
                                            [
                                              _c("h2", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "status.drawing.head"
                                                    )
                                                  )
                                                )
                                              ]),
                                              _c(
                                                "b-row",
                                                { staticClass: "status" },
                                                [
                                                  _c(
                                                    "b-col",
                                                    { attrs: { sm: "auto" } },
                                                    [
                                                      _c("svg-image", {
                                                        attrs: {
                                                          image: "statusDrawing"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _c("b-col", [
                                                    _c("h6", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "status.drawing.label"
                                                          )
                                                        )
                                                      )
                                                    ]),
                                                    _c("p", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "status.drawing.desc"
                                                          )
                                                        )
                                                      )
                                                    ])
                                                  ])
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm.ballotStatus.approved &&
                                      !_vm.ballotStatus.FRQaccepted &&
                                      _vm.transactionData &&
                                      _vm.transactionData.data.trnsConfirmed !=
                                        1
                                        ? _c(
                                            "div",
                                            { staticClass: "statusPay" },
                                            [
                                              _c("h2", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("status.pay.head")
                                                  )
                                                )
                                              ]),
                                              _c(
                                                "b-row",
                                                { staticClass: "status" },
                                                [
                                                  _c(
                                                    "b-col",
                                                    { attrs: { sm: "auto" } },
                                                    [
                                                      _c("svg-image", {
                                                        attrs: {
                                                          image: "statusPay"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "b-col",
                                                    [
                                                      _c("h6", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "status.pay.label"
                                                            )
                                                          )
                                                        )
                                                      ]),
                                                      _c(
                                                        "i18n",
                                                        {
                                                          attrs: {
                                                            path:
                                                              "status.pay.desc",
                                                            tag: "p"
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              attrs: {
                                                                place:
                                                                  "timelimit"
                                                              }
                                                            },
                                                            [
                                                              _c("strong", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm._f(
                                                                      "moment"
                                                                    )(
                                                                      _vm
                                                                        .transactionData
                                                                        .data
                                                                        .trnsExpiredTime,
                                                                      "D MMMM YYYY HH:mm"
                                                                    )
                                                                  ) +
                                                                    " WIB (GMT+7)"
                                                                )
                                                              ])
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              !_vm.ballotDataDetail
                                                .evpaJersey ||
                                              (_vm.ballotDataDetail
                                                .evpaJersey &&
                                                _vm.ballotDataDetail
                                                  .evpaJersey == "-")
                                                ? _c(
                                                    "b-button",
                                                    {
                                                      attrs: {
                                                        variant: "primary"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          _vm.showJerseyModal = !_vm.showJerseyModal
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "status.pay.jbtn"
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _c("jersey-modal", {
                                                attrs: {
                                                  showJersey:
                                                    _vm.showJerseyModal
                                                }
                                              }),
                                              _vm.ballotDataDetail.evpaJersey &&
                                              _vm.ballotDataDetail.evpaJersey !=
                                                "-"
                                                ? _c(
                                                    "b-button",
                                                    {
                                                      attrs: {
                                                        variant: "primary"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          _vm.showPaymentModal = !_vm.showPaymentModal
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "status.pay.btn"
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _c("payment-modal", {
                                                attrs: {
                                                  show: _vm.showPaymentModal,
                                                  transactionData:
                                                    _vm.transactionData,
                                                  ballotStatus: _vm.ballotStatus
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm.ballotStatus.FRQaccepted &&
                                      _vm.transactionData &&
                                      _vm.transactionData.data.trnsConfirmed !=
                                        1
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "statusFRQaccepted"
                                            },
                                            [
                                              _c("h2", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "status.FRQaccepted.head"
                                                    )
                                                  )
                                                )
                                              ]),
                                              _c(
                                                "b-row",
                                                { staticClass: "status" },
                                                [
                                                  _c(
                                                    "b-col",
                                                    { attrs: { sm: "auto" } },
                                                    [
                                                      _c("svg-image", {
                                                        attrs: {
                                                          image: "statusPay"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _c("b-col", [
                                                    _c("h6", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "status.FRQaccepted.label"
                                                          )
                                                        )
                                                      )
                                                    ]),
                                                    _c("p", {
                                                      domProps: {
                                                        innerHTML: _vm._s(
                                                          _vm.$t(
                                                            "status.FRQaccepted.desc"
                                                          )
                                                        )
                                                      }
                                                    })
                                                  ])
                                                ],
                                                1
                                              ),
                                              !_vm.ballotDataDetail
                                                .evpaJersey ||
                                              _vm.ballotDataDetail.evpaJersey ==
                                                "-"
                                                ? _c(
                                                    "b-button",
                                                    {
                                                      attrs: {
                                                        variant: "primary"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          _vm.showJerseyModal = !_vm.showJerseyModal
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "status.pay.jbtn"
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _c("jersey-modal", {
                                                attrs: {
                                                  showJersey:
                                                    _vm.showJerseyModal
                                                }
                                              }),
                                              !(
                                                !_vm.ballotDataDetail
                                                  .evpaJersey ||
                                                _vm.ballotDataDetail
                                                  .evpaJersey == "-"
                                              )
                                                ? _c(
                                                    "b-button",
                                                    {
                                                      attrs: {
                                                        disabled: "disabled",
                                                        variant: "primary"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          _vm.showPaymentModal = !_vm.showPaymentModal
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "status.pay.btn"
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _c("payment-modal", {
                                                attrs: {
                                                  show: _vm.showPaymentModal,
                                                  transactionData:
                                                    _vm.transactionData
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm.ballotStatus.bibTransferInProgess
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "statusTransferring"
                                            },
                                            [
                                              _c("h2", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "status.transferring.head"
                                                    )
                                                  )
                                                )
                                              ]),
                                              _c(
                                                "b-row",
                                                { staticClass: "status" },
                                                [
                                                  _c(
                                                    "b-col",
                                                    { attrs: { sm: "auto" } },
                                                    [
                                                      _c("svg-image", {
                                                        attrs: {
                                                          image:
                                                            "statusTransferring"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _c("b-col", [
                                                    _c("h6", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "status.transferring.label"
                                                          )
                                                        )
                                                      )
                                                    ]),
                                                    _c("p", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "status.transferring.desc"
                                                          )
                                                        )
                                                      )
                                                    ])
                                                  ])
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm.ballotStatus.confirmed
                                        ? _c(
                                            "div",
                                            { staticClass: "statusSuccess" },
                                            [
                                              _c("h2", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "status.success.head"
                                                    )
                                                  )
                                                )
                                              ]),
                                              _c(
                                                "b-row",
                                                { staticClass: "status" },
                                                [
                                                  _c(
                                                    "b-col",
                                                    { attrs: { sm: "auto" } },
                                                    [
                                                      _c("svg-image", {
                                                        attrs: {
                                                          image: "statusSuccess"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _c("b-col", [
                                                    _c("h6", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "status.success.label"
                                                          )
                                                        )
                                                      )
                                                    ]),
                                                    _c("p", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "status.success.desc"
                                                          )
                                                        )
                                                      )
                                                    ])
                                                  ])
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm.ballotStatus.confirmedViaBankJateng
                                        ? _c(
                                            "div",
                                            { staticClass: "statusBJsuccess" },
                                            [
                                              _c("h2", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "status.BJsuccess.head"
                                                    )
                                                  )
                                                )
                                              ]),
                                              _c(
                                                "b-row",
                                                { staticClass: "status" },
                                                [
                                                  _c(
                                                    "b-col",
                                                    { attrs: { sm: "auto" } },
                                                    [
                                                      _c("img", {
                                                        staticClass:
                                                          "bankJateng",
                                                        attrs: {
                                                          src:
                                                            "https://assets.heartwork.co.id/bormar/bankjateng.svg"
                                                        }
                                                      })
                                                    ]
                                                  ),
                                                  _c("b-col", [
                                                    _c("h6", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "status.BJsuccess.label"
                                                          )
                                                        )
                                                      )
                                                    ]),
                                                    _c("p", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "status.BJsuccess.desc"
                                                          )
                                                        )
                                                      )
                                                    ])
                                                  ])
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm.ballotStatus.unlucky
                                        ? _c(
                                            "div",
                                            { staticClass: "statusUnlucky" },
                                            [
                                              _c("h2", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "status.unlucky.head"
                                                    )
                                                  )
                                                )
                                              ]),
                                              _c(
                                                "b-row",
                                                { staticClass: "status" },
                                                [
                                                  _c(
                                                    "b-col",
                                                    { attrs: { sm: "auto" } },
                                                    [
                                                      _c("svg-image", {
                                                        attrs: {
                                                          image: "statusUnlucky"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _c("b-col", [
                                                    _c("h6", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "status.unlucky.label"
                                                          )
                                                        )
                                                      )
                                                    ]),
                                                    _c("p", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "status.unlucky.desc"
                                                          )
                                                        )
                                                      )
                                                    ])
                                                  ])
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm.ballotStatus.unpaid
                                        ? _c(
                                            "div",
                                            { staticClass: "statusUnpaid" },
                                            [
                                              _c("h2", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("status.unpaid.head")
                                                  )
                                                )
                                              ]),
                                              _c(
                                                "b-row",
                                                { staticClass: "status" },
                                                [
                                                  _c(
                                                    "b-col",
                                                    { attrs: { sm: "auto" } },
                                                    [
                                                      _c("svg-image", {
                                                        attrs: {
                                                          image: "statusUnpaid"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _c("b-col", [
                                                    _c("h6", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "status.unpaid.label"
                                                          )
                                                        )
                                                      )
                                                    ]),
                                                    _c("p", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "status.unpaid.desc"
                                                          )
                                                        )
                                                      )
                                                    ])
                                                  ])
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm.ballotStatus.transferred
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "statusTransferred"
                                            },
                                            [
                                              _c("h2", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "status.transferred.head"
                                                    )
                                                  )
                                                )
                                              ]),
                                              _c(
                                                "b-row",
                                                { staticClass: "status" },
                                                [
                                                  _c(
                                                    "b-col",
                                                    { attrs: { sm: "auto" } },
                                                    [
                                                      _c("svg-image", {
                                                        attrs: {
                                                          image:
                                                            "statusTransferred"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _c("b-col", [
                                                    _c("h6", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "status.transferred.label"
                                                          )
                                                        )
                                                      )
                                                    ]),
                                                    _c("p", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "status.transferred.desc"
                                                          )
                                                        )
                                                      )
                                                    ])
                                                  ])
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm.ballotStatus.closed
                                        ? _c(
                                            "div",
                                            { staticClass: "statusClosed" },
                                            [
                                              _c("h2", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("status.closed.head")
                                                  )
                                                )
                                              ]),
                                              _c(
                                                "b-row",
                                                { staticClass: "status" },
                                                [
                                                  _c(
                                                    "b-col",
                                                    { attrs: { sm: "auto" } },
                                                    [
                                                      _c("svg-image", {
                                                        attrs: {
                                                          image: "statusClosed"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _c("b-col", [
                                                    _c("h6", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "status.closed.label"
                                                          )
                                                        )
                                                      )
                                                    ]),
                                                    _c("p", {
                                                      domProps: {
                                                        innerHTML: _vm._s(
                                                          _vm.$t(
                                                            "status.closed.desc"
                                                          )
                                                        )
                                                      }
                                                    })
                                                  ])
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  ),
                                  _vm.ballotData && _vm.ballotDataDetail
                                    ? _c(
                                        "div",
                                        { staticClass: "regData" },
                                        [
                                          _c(
                                            "b-row",
                                            { staticClass: "regCategory" },
                                            [
                                              _c(
                                                "b-col",
                                                { attrs: { md: "auto" } },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "groupLabel"
                                                    },
                                                    [
                                                      _c("label", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "regData.category.race"
                                                            )
                                                          )
                                                        )
                                                      ])
                                                    ]
                                                  ),
                                                  _c("h1", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.ballotDataDetail
                                                          .evrlEvpaCategory
                                                      )
                                                    )
                                                  ])
                                                ]
                                              ),
                                              _c("b-col", [
                                                _c(
                                                  "div",
                                                  { staticClass: "groupLabel" },
                                                  [
                                                    _c("label", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "regData.category.code"
                                                          )
                                                        )
                                                      )
                                                    ])
                                                  ]
                                                ),
                                                _c("h5", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.ballotData.mregOrderId
                                                    )
                                                  )
                                                ]),
                                                _c("p", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f("moment")(
                                                        _vm.ballotData
                                                          .mregCreatedTime,
                                                        "D MMMM YYYY - HH:mm"
                                                      )
                                                    ) + " WIB (GMT+7)"
                                                  )
                                                ])
                                              ])
                                            ],
                                            1
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "groupLabel" },
                                            [
                                              _c("label", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "regData.details.head"
                                                    )
                                                  )
                                                )
                                              ])
                                            ]
                                          ),
                                          _c("table", [
                                            _c("tbody", [
                                              _vm.ballotDataDetail.evpaWave &&
                                              _vm.ballotDataDetail.evpaWave !=
                                                "00:00"
                                                ? _c("tr", [
                                                    _c(
                                                      "td",
                                                      { staticClass: "heady" },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "regData.details.corral"
                                                            )
                                                          )
                                                        )
                                                      ]
                                                    ),
                                                    _c("td", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.ballotDataDetail
                                                            .evpaWave
                                                        )
                                                      )
                                                    ])
                                                  ])
                                                : _vm._e(),
                                              _vm.ballotDataDetail.evpaFRtime &&
                                              _vm.ballotDataDetail.evpaFRtime !=
                                                "00:00"
                                                ? _c("tr", [
                                                    _c(
                                                      "td",
                                                      { staticClass: "heady" },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "regData.details.corral"
                                                            )
                                                          )
                                                        )
                                                      ]
                                                    ),
                                                    _c("td", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.ballotDataDetail
                                                            .evpaFRtime
                                                        )
                                                      )
                                                    ])
                                                  ])
                                                : _vm._e(),
                                              _c("tr", [
                                                _c(
                                                  "td",
                                                  { staticClass: "heady" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "regData.details.bib"
                                                        )
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _c("td", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.ballotDataDetail
                                                        .evpaBIBName
                                                    )
                                                  )
                                                ])
                                              ]),
                                              _vm.ballotDataDetail.evpaJersey !=
                                              "-"
                                                ? _c("tr", [
                                                    _c(
                                                      "td",
                                                      { staticClass: "heady" },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "regData.details.jersey"
                                                            )
                                                          )
                                                        )
                                                      ]
                                                    ),
                                                    _c("td", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.ballotDataDetail
                                                            .evpaJersey
                                                        )
                                                      )
                                                    ])
                                                  ])
                                                : _vm._e(),
                                              _vm.ballotDataDetail
                                                .evpaCommunity &&
                                              _vm.ballotDataDetail
                                                .evpaCommunity != "-"
                                                ? _c("tr", [
                                                    _c(
                                                      "td",
                                                      { staticClass: "heady" },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "regData.details.community"
                                                            )
                                                          )
                                                        )
                                                      ]
                                                    ),
                                                    _c("td", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.ballotDataDetail
                                                            .evpaCommunity
                                                        )
                                                      )
                                                    ])
                                                  ])
                                                : _vm._e()
                                            ])
                                          ]),
                                          _vm.userProfile.fastRunnerInfo
                                            ? _c(
                                                "div",
                                                { staticClass: "FRQdata" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "groupLabel"
                                                    },
                                                    [
                                                      _c("label", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "regData.frq.head"
                                                            )
                                                          )
                                                        )
                                                      ])
                                                    ]
                                                  ),
                                                  _c("table", [
                                                    _c("tbody", [
                                                      _c("tr", [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass: "heady"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "regData.frq.qrace"
                                                                )
                                                              )
                                                            )
                                                          ]
                                                        ),
                                                        _c("td", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.userProfile
                                                                .fastRunnerInfo
                                                                .mmfrEventName
                                                            )
                                                          )
                                                        ])
                                                      ]),
                                                      _c("tr", [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass: "heady"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "regData.frq.qcategory"
                                                                )
                                                              )
                                                            )
                                                          ]
                                                        ),
                                                        _c("td", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.userProfile
                                                                .fastRunnerInfo
                                                                .mmfrDescription
                                                            )
                                                          )
                                                        ])
                                                      ]),
                                                      _c("tr", [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass: "heady"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "regData.frq.qtime"
                                                                )
                                                              )
                                                            )
                                                          ]
                                                        ),
                                                        _c("td", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.userProfile
                                                                .fastRunnerInfo
                                                                .mmfrResultTime
                                                            )
                                                          )
                                                        ])
                                                      ])
                                                    ])
                                                  ])
                                                ]
                                              )
                                            : _vm._e(),
                                          _c(
                                            "div",
                                            { staticClass: "groupLabel" },
                                            [
                                              _c("label", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "regData.emergency.head"
                                                    )
                                                  )
                                                )
                                              ])
                                            ]
                                          ),
                                          _c("table", [
                                            _c("tbody", [
                                              _c("tr", [
                                                _c(
                                                  "td",
                                                  { staticClass: "heady" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "regData.emergency.name"
                                                        )
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _c("td", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.ballotDataDetail
                                                        .evpaEmergencyContactName
                                                    )
                                                  )
                                                ])
                                              ]),
                                              _c("tr", [
                                                _c(
                                                  "td",
                                                  { staticClass: "heady" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "regData.emergency.number"
                                                        )
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _c("td", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.ballotDataDetail
                                                        .evpaEmergencyContactNumber
                                                    )
                                                  )
                                                ])
                                              ]),
                                              _c("tr", [
                                                _c(
                                                  "td",
                                                  { staticClass: "heady" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "regData.emergency.medic"
                                                        )
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _c("td", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.ballotDataDetail
                                                        .evpaMedicalTreatment
                                                    )
                                                  )
                                                ])
                                              ])
                                            ])
                                          ])
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm.invited
                                    ? _c(
                                        "div",
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "groupLabel" },
                                            [
                                              _c("label", [
                                                _vm._v(
                                                  "KETENTUAN TAMBAHAN BOROBUDUR MARATHON ELITE RACE 2020"
                                                )
                                              ])
                                            ]
                                          ),
                                          _c("ol", [
                                            _c("li", [
                                              _vm._v(
                                                "Atlet wajib menjalani tes Covid-19 minimal 3 (tiga) kali, sebelum berangkat ke tempat acara, selama berada di lokasi acara, dan sebelum pulang dari tempat acara. "
                                              )
                                            ]),
                                            _c("li", [
                                              _vm._v(
                                                "Apabila atlet gagal menjalani salah satu tes Covid-19 , atau salah satu hasil tes menunjukan hasil positif maka atlet akan dihimbau untuk masuk ke dalam tempat atau ruang isolasi yang ditentukan penyelenggara, dan tidak berhak mengikuti acara Borobudur Marathon Elite Race 2020."
                                              )
                                            ]),
                                            _c("li", [
                                              _vm._v(
                                                "Atlet tidak diperkenankan untuk didampingi oleh pelatih selama acara Borobudur Marathon Elite Race 2020 berlangsung."
                                              )
                                            ]),
                                            _c("li", [
                                              _vm._v(
                                                "Atlet tidak diperkenankan untuk menerima dan melakukan kunjungan selama acara Borobudur Marathon Elite Race 2020 berlangsung."
                                              )
                                            ]),
                                            _c("li", [
                                              _vm._v(
                                                "Atlet wajib tinggal di tempat akomodasi atlet yang sudah ditentukan oleh penyelenggara. Apabila atlet menginap di tempat lain selain akomodasi yang sudah disediakan, atlet dapat didiskualifikasi dan tidak dapat berpartisipasi dalam perlombaan.​"
                                              )
                                            ]),
                                            _c("li", [
                                              _vm._v(
                                                "Atlet harus mengikuti protokol kesehatan yang ditetapkan penyelenggara, termasuk namun tidak terbatas kepada, pembatasan jarak fisik, penggunaan masker, mencuci tangan dan menggunakan hand sanitizer . Pelanggaran pelaksanaan protokol kesehatan dapat menjadi pertimbangan penyelenggara untuk menghentikan atlet dalam keikutsertaan mereka di Borobudur Marathon Elite Race 2020​"
                                              )
                                            ]),
                                            _c("li", [
                                              _vm._v(
                                                "Atlet diharuskan menggunakan moda transportasi dan fasilitas yang sudah disediakan oleh penyelenggara. Pelanggaran penggunaan moda transportasi dan fasilitas yang sudah disediakan oleh penyelenggara, dapat menjadi pertimbangan untuk menghentikan atlet dalam keikutsertaan mereka di Borobudur Marathon Elite Race 2020."
                                              )
                                            ]),
                                            _c("li", [
                                              _vm._v(
                                                "Atlet wajib mengikuti jadwal rangkaian acara yang dibuat oleh Panitia Borobudur Marathon Elite Race 2020."
                                              )
                                            ]),
                                            _c("li", [
                                              _vm._v(
                                                "Atlet wajib mengikuti assesment yang telah ditetapkan oleh penyelenggara bersama medical director,  14 hari sebelum lomba dan 14 hari setelah lomba berlangsung.​"
                                              )
                                            ]),
                                            _c("li", [
                                              _vm._v(
                                                "Hal-hal lain terkait syarat dan ketentuan keikutsertaan dalam Borobudur Marathon Elite Race 2020 dapat ditambahkan sewaktu-waktu oleh penyelenggara dan akan menginformasikan penambahan itu kepada para atlet undangan Borobudur Marathon Elite Race 2020."
                                              )
                                            ])
                                          ]),
                                          !_vm.transactionData
                                            ? _c(
                                                "b-button",
                                                {
                                                  directives: [
                                                    {
                                                      name: "b-modal",
                                                      rawName:
                                                        "v-b-modal.registrationModal",
                                                      modifiers: {
                                                        registrationModal: true
                                                      }
                                                    }
                                                  ],
                                                  attrs: {
                                                    variant: "primary",
                                                    disabled:
                                                      _vm.channel == null
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("status.idle.btn")
                                                    )
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      )
                    : _vm._e()
                ],
                1
              ),
              !_vm.event2020
                ? _c(
                    "div",
                    [
                      _c(
                        "b-row",
                        {
                          staticClass: "dashRow",
                          class: {
                            dashDisabled:
                              !_vm.ballotStatus.readyToRegister ||
                              !_vm.saveDuitOpen
                          }
                        },
                        [
                          _c(
                            "b-col",
                            { attrs: { md: "6" } },
                            [
                              _c(
                                "b-card",
                                {
                                  staticClass: "dashCard",
                                  attrs: {
                                    title: _vm.$t("bankjateng.card.head"),
                                    "img-src": "/public/images/bj.jpg",
                                    "img-alt": "Bank Jateng Program",
                                    "img-top": ""
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "bankjatengCard" },
                                    [
                                      _c("b-card-text", [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t\t" +
                                            _vm._s(
                                              _vm.$t("bankjateng.card.desc")
                                            ) +
                                            "\n\t\t\t\t\t\t\t\t"
                                        )
                                      ]),
                                      !_vm.programData
                                        ? _c(
                                            "b-button",
                                            {
                                              directives: [
                                                {
                                                  name: "b-modal",
                                                  rawName:
                                                    "v-b-modal.registrationModal",
                                                  modifiers: {
                                                    registrationModal: true
                                                  }
                                                }
                                              ],
                                              attrs: {
                                                block: "",
                                                variant: "primary",
                                                disabled:
                                                  !_vm.ballotStatus
                                                    .readyToRegister || true
                                              },
                                              on: {
                                                click: function($event) {
                                                  _vm.channel = "JATENG"
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("bankjateng.card.btn")
                                                )
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  ),
                                  _vm.ballotStatus.readyToRegister
                                    ? _c(
                                        "div",
                                        { staticClass: "bankjatengStatus" },
                                        [
                                          _vm.ballotStatus.confirmedViaSaveDuit
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass: "statusSuccess"
                                                },
                                                [
                                                  _c(
                                                    "b-row",
                                                    { staticClass: "status" },
                                                    [
                                                      _c(
                                                        "b-col",
                                                        [
                                                          _c("svg-image", {
                                                            attrs: {
                                                              image:
                                                                "statusSuccess"
                                                            }
                                                          }),
                                                          _c("h6", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "bankjateng.status.success.label"
                                                                )
                                                              )
                                                            )
                                                          ]),
                                                          _c("p", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "bankjateng.status.success.desc"
                                                                )
                                                              )
                                                            )
                                                          ])
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            : _c("div", [
                                                _vm.programData &&
                                                !_vm.ballotStatus
                                                  .waitingSaveduitSettlement &&
                                                !_vm.ballotStatus
                                                  .saveduitExpired
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass: "statusPay"
                                                      },
                                                      [
                                                        _c(
                                                          "b-row",
                                                          {
                                                            staticClass:
                                                              "status"
                                                          },
                                                          [
                                                            _c(
                                                              "b-col",
                                                              [
                                                                _c(
                                                                  "svg-image",
                                                                  {
                                                                    attrs: {
                                                                      image:
                                                                        "statusPay"
                                                                    }
                                                                  }
                                                                ),
                                                                _c("h6", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "bankjateng.status.pay.label"
                                                                      )
                                                                    )
                                                                  )
                                                                ]),
                                                                _c(
                                                                  "i18n",
                                                                  {
                                                                    attrs: {
                                                                      path:
                                                                        "bankjateng.status.pay.desc",
                                                                      tag: "p"
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        attrs: {
                                                                          place:
                                                                            "timelimit"
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "strong",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm._f(
                                                                                  "moment"
                                                                                )(
                                                                                  _vm
                                                                                    .programData
                                                                                    .data
                                                                                    .trnsExpiredTime,
                                                                                  "D MMMM YYYY HH:mm"
                                                                                )
                                                                              ) +
                                                                                " WIB (GMT+7)"
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "b-button",
                                                          {
                                                            directives: [
                                                              {
                                                                name: "b-modal",
                                                                rawName:
                                                                  "v-b-modal.paymentModal",
                                                                modifiers: {
                                                                  paymentModal: true
                                                                }
                                                              }
                                                            ],
                                                            attrs: {
                                                              block: "",
                                                              variant: "primary"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "bankjateng.status.pay.btn"
                                                                )
                                                              )
                                                            )
                                                          ]
                                                        ),
                                                        _c("payment-modal", {
                                                          attrs: {
                                                            transactionData:
                                                              _vm.programData
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm.programData &&
                                                _vm.ballotStatus
                                                  .waitingSaveduitSettlement
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass: "statusPay"
                                                      },
                                                      [
                                                        _c(
                                                          "b-row",
                                                          {
                                                            staticClass:
                                                              "status"
                                                          },
                                                          [
                                                            _c(
                                                              "b-col",
                                                              [
                                                                _c(
                                                                  "svg-image",
                                                                  {
                                                                    attrs: {
                                                                      image:
                                                                        "statusPay"
                                                                    }
                                                                  }
                                                                ),
                                                                _c("h6", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "bankjateng.status.pay.label"
                                                                      )
                                                                    )
                                                                  )
                                                                ]),
                                                                _c(
                                                                  "i18n",
                                                                  {
                                                                    attrs: {
                                                                      path:
                                                                        "bankjateng.status.pay.desc",
                                                                      tag: "p"
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        attrs: {
                                                                          place:
                                                                            "timelimit"
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "strong",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm._f(
                                                                                  "moment"
                                                                                )(
                                                                                  _vm
                                                                                    .programData
                                                                                    .data
                                                                                    .trnsExpiredTime,
                                                                                  "D MMMM YYYY HH:mm"
                                                                                )
                                                                              ) +
                                                                                " WIB (GMT+7)"
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "b-button",
                                                          {
                                                            directives: [
                                                              {
                                                                name: "b-modal",
                                                                rawName:
                                                                  "v-b-modal.paymentModal",
                                                                modifiers: {
                                                                  paymentModal: true
                                                                }
                                                              }
                                                            ],
                                                            attrs: {
                                                              block: "",
                                                              variant: "primary"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "bankjateng.status.pay.btn"
                                                                )
                                                              )
                                                            )
                                                          ]
                                                        ),
                                                        _c("payment-modal", {
                                                          attrs: {
                                                            transactionData:
                                                              _vm.programData
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm.ballotStatus.saveduitExpired
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "statusUnpaid"
                                                      },
                                                      [
                                                        _c(
                                                          "b-row",
                                                          {
                                                            staticClass:
                                                              "status"
                                                          },
                                                          [
                                                            _c(
                                                              "b-col",
                                                              [
                                                                _c(
                                                                  "svg-image",
                                                                  {
                                                                    attrs: {
                                                                      image:
                                                                        "statusUnpaid"
                                                                    }
                                                                  }
                                                                ),
                                                                _c("h6", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "bankjateng.status.unpaid.label"
                                                                      )
                                                                    )
                                                                  )
                                                                ]),
                                                                _c("p", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "bankjateng.status.unpaid.desc"
                                                                      )
                                                                    )
                                                                  )
                                                                ])
                                                              ],
                                                              1
                                                            )
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "b-button",
                                                          {
                                                            directives: [
                                                              {
                                                                name: "b-modal",
                                                                rawName:
                                                                  "v-b-modal.registrationModal",
                                                                modifiers: {
                                                                  registrationModal: true
                                                                }
                                                              }
                                                            ],
                                                            attrs: {
                                                              block: "",
                                                              variant: "primary"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                _vm.channel =
                                                                  "JATENG"
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "bankjateng.status.unpaid.btn"
                                                                )
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e()
                                              ])
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.ballotStatus.confirmedViaSaveDuit
                                    ? _c(
                                        "div",
                                        { staticClass: "bankjatengReg" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "groupLabel" },
                                            [
                                              _c("label", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "bankjateng.data.head"
                                                    )
                                                  )
                                                )
                                              ])
                                            ]
                                          ),
                                          _c("table", [
                                            _c("tbody", [
                                              _c("tr", [
                                                _c(
                                                  "td",
                                                  { staticClass: "heady" },
                                                  [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t\t\t" +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "bankjateng.data.name"
                                                          )
                                                        ) +
                                                        "\n\t\t\t\t\t\t\t\t\t\t"
                                                    )
                                                  ]
                                                ),
                                                _c("td", [
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\t\t\t\t" +
                                                      _vm._s(
                                                        _vm.programData.data
                                                          .trnsUserName
                                                      ) +
                                                      "\n\t\t\t\t\t\t\t\t\t"
                                                  )
                                                ])
                                              ]),
                                              _c("tr", [
                                                _c(
                                                  "td",
                                                  { staticClass: "heady" },
                                                  [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t\t\t" +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "bankjateng.data.category"
                                                          )
                                                        ) +
                                                        "\n\t\t\t\t\t\t\t\t\t\t"
                                                    )
                                                  ]
                                                ),
                                                _c("td", [
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\t\t\t\t" +
                                                      _vm._s(
                                                        _vm.programData.linked
                                                          .evrlTrnsId[0]
                                                          .evrlEvpaCategory
                                                      ) +
                                                      "\n\t\t\t\t\t\t\t\t\t"
                                                  )
                                                ])
                                              ]),
                                              _c("tr", [
                                                _c(
                                                  "td",
                                                  { staticClass: "heady" },
                                                  [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t\t\t" +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "bankjateng.data.bibname"
                                                          )
                                                        ) +
                                                        "\n\t\t\t\t\t\t\t\t\t\t"
                                                    )
                                                  ]
                                                ),
                                                _c("td", [
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\t\t\t\t" +
                                                      _vm._s(
                                                        _vm.programData.linked
                                                          .evrlTrnsId[0]
                                                          .evpaBIBName
                                                      ) +
                                                      "\n\t\t\t\t\t\t\t\t\t"
                                                  )
                                                ])
                                              ]),
                                              _c("tr", [
                                                _c(
                                                  "td",
                                                  { staticClass: "heady" },
                                                  [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t\t\t" +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "bankjateng.data.community"
                                                          )
                                                        ) +
                                                        "\n\t\t\t\t\t\t\t\t\t\t"
                                                    )
                                                  ]
                                                ),
                                                _c("td", [
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\t\t\t\t" +
                                                      _vm._s(
                                                        _vm.programData.linked
                                                          .evrlTrnsId[0]
                                                          .evpaCommunity
                                                      ) +
                                                      "\n\t\t\t\t\t\t\t\t\t"
                                                  )
                                                ])
                                              ]),
                                              _c("tr", [
                                                _c(
                                                  "td",
                                                  { staticClass: "heady" },
                                                  [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t\t\t" +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "bankjateng.data.jersey"
                                                          )
                                                        ) +
                                                        "\n\t\t\t\t\t\t\t\t\t\t"
                                                    )
                                                  ]
                                                ),
                                                _c("td", [
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\t\t\t\t" +
                                                      _vm._s(
                                                        _vm.programData.linked
                                                          .evrlTrnsId[0]
                                                          .evpaJersey
                                                      ) +
                                                      "\n\t\t\t\t\t\t\t\t\t"
                                                  )
                                                ])
                                              ]),
                                              _c("tr", [
                                                _c(
                                                  "td",
                                                  { staticClass: "heady" },
                                                  [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t\t\t" +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "bankjateng.data.emergencyname"
                                                          )
                                                        ) +
                                                        "\n\t\t\t\t\t\t\t\t\t\t"
                                                    )
                                                  ]
                                                ),
                                                _c("td", [
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\t\t\t\t" +
                                                      _vm._s(
                                                        _vm.programData.linked
                                                          .evrlTrnsId[0]
                                                          .evpaEmergencyContactName
                                                      ) +
                                                      "\n\t\t\t\t\t\t\t\t\t"
                                                  )
                                                ])
                                              ]),
                                              _c("tr", [
                                                _c(
                                                  "td",
                                                  { staticClass: "heady" },
                                                  [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t\t\t" +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "bankjateng.data.emergencycontact"
                                                          )
                                                        ) +
                                                        "\n\t\t\t\t\t\t\t\t\t\t"
                                                    )
                                                  ]
                                                ),
                                                _c("td", [
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\t\t\t\t" +
                                                      _vm._s(
                                                        _vm.programData.linked
                                                          .evrlTrnsId[0]
                                                          .evpaEmergencyContactNumber
                                                      ) +
                                                      "\n\t\t\t\t\t\t\t\t\t"
                                                  )
                                                ])
                                              ]),
                                              _c("tr", [
                                                _c(
                                                  "td",
                                                  { staticClass: "heady" },
                                                  [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t\t\t" +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "bankjateng.data.medical"
                                                          )
                                                        ) +
                                                        "\n\t\t\t\t\t\t\t\t\t\t"
                                                    )
                                                  ]
                                                ),
                                                _c("td", [
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\t\t\t\t" +
                                                      _vm._s(
                                                        _vm.programData.linked
                                                          .evrlTrnsId[0]
                                                          .evpaMedicalTreatment
                                                      ) +
                                                      "\n\t\t\t\t\t\t\t\t\t"
                                                  )
                                                ])
                                              ])
                                            ])
                                          ])
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              )
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { md: "6" } },
                            [
                              _c(
                                "b-card",
                                {
                                  staticClass: "dashCard dashDisabled",
                                  attrs: {
                                    title: _vm.$t("friendship.card.head"),
                                    "img-src": "/public/images/fr.jpg",
                                    "img-alt": "Friendship Run",
                                    "img-top": ""
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "friendshipCard" },
                                    [
                                      _c("b-card-text", [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t\t" +
                                            _vm._s(
                                              _vm.$t("friendship.card.desc")
                                            ) +
                                            "\n\t\t\t\t\t\t\t\t"
                                        )
                                      ]),
                                      _c(
                                        "b-button",
                                        {
                                          directives: [
                                            {
                                              name: "b-modal",
                                              rawName:
                                                "v-b-modal.registrationModal",
                                              modifiers: {
                                                registrationModal: true
                                              }
                                            }
                                          ],
                                          attrs: {
                                            block: "",
                                            variant: "primary",
                                            disabled: "disabled"
                                          },
                                          on: {
                                            click: function($event) {
                                              _vm.channel = "FRIENDSHIP"
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("friendship.card.btn")
                                            )
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm.transactionStatus
                                    ? _c(
                                        "div",
                                        { staticClass: "friendshipStatus" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "statusPay" },
                                            [
                                              _c(
                                                "b-row",
                                                { staticClass: "status" },
                                                [
                                                  _c(
                                                    "b-col",
                                                    [
                                                      _c("svg-image", {
                                                        attrs: {
                                                          image: "statusPay"
                                                        }
                                                      }),
                                                      _c("h6", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "friendship.status.pay.label"
                                                            )
                                                          )
                                                        )
                                                      ]),
                                                      _c(
                                                        "i18n",
                                                        {
                                                          attrs: {
                                                            path:
                                                              "friendship.status.pay.desc",
                                                            tag: "p"
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              attrs: {
                                                                place:
                                                                  "timelimit"
                                                              }
                                                            },
                                                            [
                                                              _c("strong", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm._f(
                                                                      "moment"
                                                                    )(
                                                                      _vm
                                                                        .transactionData
                                                                        .data
                                                                        .trnsExpiredTime,
                                                                      "D MMMM YYYY HH:mm"
                                                                    )
                                                                  ) +
                                                                    " WIB (GMT+7)"
                                                                )
                                                              ])
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _c(
                                                "b-button",
                                                {
                                                  directives: [
                                                    {
                                                      name: "b-modal",
                                                      rawName:
                                                        "v-b-modal.paymentModal",
                                                      modifiers: {
                                                        paymentModal: true
                                                      }
                                                    }
                                                  ],
                                                  attrs: {
                                                    block: "",
                                                    variant: "primary"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "friendship.status.pay.btn"
                                                      )
                                                    )
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "statusUnpaid" },
                                            [
                                              _c(
                                                "b-row",
                                                { staticClass: "status" },
                                                [
                                                  _c(
                                                    "b-col",
                                                    [
                                                      _c("svg-image", {
                                                        attrs: {
                                                          image: "statusUnpaid"
                                                        }
                                                      }),
                                                      _c("h6", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "friendship.status.unpaid.label"
                                                            )
                                                          )
                                                        )
                                                      ]),
                                                      _c("p", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "friendship.status.unpaid.desc"
                                                            )
                                                          )
                                                        )
                                                      ])
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _c(
                                                "b-button",
                                                {
                                                  directives: [
                                                    {
                                                      name: "b-modal",
                                                      rawName:
                                                        "v-b-modal.registrationModal",
                                                      modifiers: {
                                                        registrationModal: true
                                                      }
                                                    }
                                                  ],
                                                  attrs: {
                                                    block: "",
                                                    variant: "primary"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      _vm.channel = "FRIENDSHIP"
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "friendship.status.unpaid.btn"
                                                      )
                                                    )
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "statusSuccess" },
                                            [
                                              _c(
                                                "b-row",
                                                { staticClass: "status" },
                                                [
                                                  _c(
                                                    "b-col",
                                                    [
                                                      _c("svg-image", {
                                                        attrs: {
                                                          image: "statusSuccess"
                                                        }
                                                      }),
                                                      _c("h6", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "friendship.status.success.label"
                                                            )
                                                          )
                                                        )
                                                      ]),
                                                      _c("p", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "friendship.status.success.desc"
                                                            )
                                                          )
                                                        )
                                                      ])
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.transactionStatus
                                    ? _c(
                                        "div",
                                        { staticClass: "friendshipReg" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "groupLabel" },
                                            [
                                              _c("label", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "friendship.data.head"
                                                    )
                                                  )
                                                )
                                              ])
                                            ]
                                          ),
                                          _c("table", [
                                            _c("tbody", [
                                              _c("tr", [
                                                _c(
                                                  "td",
                                                  { staticClass: "heady" },
                                                  [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t\t\t" +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "friendship.data.code"
                                                          )
                                                        ) +
                                                        "\n\t\t\t\t\t\t\t\t\t\t"
                                                    )
                                                  ]
                                                ),
                                                _c("td", [
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\t\t\t\tLARI2020\n\t\t\t\t\t\t\t\t\t"
                                                  )
                                                ])
                                              ]),
                                              _c("tr", [
                                                _c(
                                                  "td",
                                                  { staticClass: "heady" },
                                                  [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t\t\t" +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "friendship.data.bib"
                                                          )
                                                        ) +
                                                        "\n\t\t\t\t\t\t\t\t\t\t"
                                                    )
                                                  ]
                                                ),
                                                _c("td", [
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\t\t\t\t1234\n\t\t\t\t\t\t\t\t\t"
                                                  )
                                                ])
                                              ])
                                            ])
                                          ]),
                                          _c(
                                            "b-button",
                                            {
                                              attrs: {
                                                href:
                                                  "https://borobudurmarathon.com/friendship-run",
                                                block: "",
                                                variant: "primary"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("friendship.data.btn")
                                                )
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "b-row",
                        { staticClass: "dashRow" },
                        [
                          _c(
                            "b-col",
                            { attrs: { md: "12" } },
                            [
                              _c(
                                "b-card-group",
                                { attrs: { deck: "" } },
                                [
                                  _c(
                                    "b-card",
                                    {
                                      staticClass: "dashCard dashDisabled",
                                      attrs: {
                                        title: _vm.$t("shuttle.card.head"),
                                        "img-src": "/public/images/bus.jpg",
                                        "img-alt": "Shuttle Bus",
                                        "img-top": ""
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "busCard" },
                                        [
                                          _c("b-card-text", [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t\t" +
                                                _vm._s(
                                                  _vm.$t("shuttle.card.desc")
                                                ) +
                                                "\n\t\t\t\t\t\t\t\t"
                                            )
                                          ]),
                                          _c(
                                            "b-button",
                                            {
                                              directives: [
                                                {
                                                  name: "b-modal",
                                                  rawName: "v-b-modal.busModal",
                                                  modifiers: { busModal: true }
                                                }
                                              ],
                                              attrs: {
                                                block: "",
                                                variant: "primary",
                                                disabled: "disabled"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("shuttle.card.btn")
                                                )
                                              )
                                            ]
                                          ),
                                          _c("bus-modal")
                                        ],
                                        1
                                      ),
                                      _vm.transactionStatus
                                        ? _c(
                                            "div",
                                            { staticClass: "busStatus" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "statusPay" },
                                                [
                                                  _c(
                                                    "b-row",
                                                    { staticClass: "status" },
                                                    [
                                                      _c(
                                                        "b-col",
                                                        [
                                                          _c("svg-image", {
                                                            attrs: {
                                                              image: "statusPay"
                                                            }
                                                          }),
                                                          _c("h6", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "shuttle.status.pay.label"
                                                                )
                                                              )
                                                            )
                                                          ]),
                                                          _c("p", {
                                                            domProps: {
                                                              innerHTML: _vm._s(
                                                                _vm.$t(
                                                                  "shuttle.status.pay.desc"
                                                                )
                                                              )
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "b-button",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "b-modal",
                                                          rawName:
                                                            "v-b-modal.paymentModal",
                                                          modifiers: {
                                                            paymentModal: true
                                                          }
                                                        }
                                                      ],
                                                      attrs: {
                                                        block: "",
                                                        variant: "primary"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "shuttle.status.pay.btn"
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              ),
                                              _c(
                                                "div",
                                                { staticClass: "statusUnpaid" },
                                                [
                                                  _c(
                                                    "b-row",
                                                    { staticClass: "status" },
                                                    [
                                                      _c(
                                                        "b-col",
                                                        [
                                                          _c("svg-image", {
                                                            attrs: {
                                                              image:
                                                                "statusUnpaid"
                                                            }
                                                          }),
                                                          _c("h6", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "shuttle.status.unpaid.label"
                                                                )
                                                              )
                                                            )
                                                          ]),
                                                          _c("p", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "shuttle.status.unpaid.desc"
                                                                )
                                                              )
                                                            )
                                                          ])
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "b-button",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "b-modal",
                                                          rawName:
                                                            "v-b-modal.busModal",
                                                          modifiers: {
                                                            busModal: true
                                                          }
                                                        }
                                                      ],
                                                      attrs: {
                                                        block: "",
                                                        variant: "primary"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "friendship.status.unpaid.btn"
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "statusSuccess"
                                                },
                                                [
                                                  _c(
                                                    "b-row",
                                                    { staticClass: "status" },
                                                    [
                                                      _c(
                                                        "b-col",
                                                        [
                                                          _c("svg-image", {
                                                            attrs: {
                                                              image:
                                                                "iconBusTicket"
                                                            }
                                                          }),
                                                          _c("h6", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "shuttle.status.success.label"
                                                                )
                                                              )
                                                            )
                                                          ]),
                                                          _c("p", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "shuttle.status.success.desc"
                                                                )
                                                              )
                                                            )
                                                          ])
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm.transactionStatus
                                        ? _c(
                                            "div",
                                            { staticClass: "busTicket" },
                                            [
                                              _c("table", [
                                                _c("tbody", [
                                                  _c("tr", [
                                                    _c(
                                                      "td",
                                                      { staticClass: "heady" },
                                                      [
                                                        _vm._v(
                                                          "\n\t\t\t\t\t\t\t\t\t\t" +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "shuttle.data.code"
                                                              )
                                                            ) +
                                                            "\n\t\t\t\t\t\t\t\t\t\t"
                                                        )
                                                      ]
                                                    ),
                                                    _c("td", [
                                                      _vm._v(
                                                        "\n\t\t\t\t\t\t\t\t\t\tBUS2020\n\t\t\t\t\t\t\t\t\t"
                                                      )
                                                    ])
                                                  ]),
                                                  _c("tr", [
                                                    _c(
                                                      "td",
                                                      { staticClass: "heady" },
                                                      [
                                                        _vm._v(
                                                          "\n\t\t\t\t\t\t\t\t\t\t" +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "shuttle.data.point"
                                                              )
                                                            ) +
                                                            "\n\t\t\t\t\t\t\t\t\t\t"
                                                        )
                                                      ]
                                                    ),
                                                    _c("td", [
                                                      _vm._v(
                                                        "\n\t\t\t\t\t\t\t\t\t\tTelevisi Republik Indonesia Yogyakarta\n\t\t\t\t\t\t\t\t\t"
                                                      )
                                                    ])
                                                  ]),
                                                  _c("tr", [
                                                    _c(
                                                      "td",
                                                      { staticClass: "heady" },
                                                      [
                                                        _vm._v(
                                                          "\n\t\t\t\t\t\t\t\t\t\t" +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "shuttle.data.dep"
                                                              )
                                                            ) +
                                                            "\n\t\t\t\t\t\t\t\t\t\t"
                                                        )
                                                      ]
                                                    ),
                                                    _c("td", [
                                                      _vm._v(
                                                        "\n\t\t\t\t\t\t\t\t\t\t02.00 - 02.30 WIB (GMT+7)\n\t\t\t\t\t\t\t\t\t"
                                                      )
                                                    ])
                                                  ]),
                                                  _c("tr", [
                                                    _c(
                                                      "td",
                                                      { staticClass: "heady" },
                                                      [
                                                        _vm._v(
                                                          "\n\t\t\t\t\t\t\t\t\t\t" +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "shuttle.data.ret"
                                                              )
                                                            ) +
                                                            "\n\t\t\t\t\t\t\t\t\t\t"
                                                        )
                                                      ]
                                                    ),
                                                    _c("td", [
                                                      _vm._v(
                                                        "\n\t\t\t\t\t\t\t\t\t\t12.00 WIB (GMT+7)\n\t\t\t\t\t\t\t\t\t"
                                                      )
                                                    ])
                                                  ])
                                                ])
                                              ])
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  ),
                                  _c(
                                    "b-card",
                                    {
                                      staticClass: "dashCard dashDisabled",
                                      attrs: {
                                        title: _vm.$t("bib.card.head"),
                                        "img-src": "/public/images/bib.jpg",
                                        "img-alt": "Bib Transfer",
                                        "img-top": ""
                                      }
                                    },
                                    [
                                      _c("b-card-text", [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t" +
                                            _vm._s(_vm.$t("bib.card.desc")) +
                                            "\n\t\t\t\t\t\t\t"
                                        )
                                      ]),
                                      _c(
                                        "b-button",
                                        {
                                          directives: [
                                            {
                                              name: "b-modal",
                                              rawName: "v-b-modal.bibModal",
                                              modifiers: { bibModal: true }
                                            }
                                          ],
                                          attrs: {
                                            block: "",
                                            variant: "primary",
                                            disabled: "disabled"
                                          }
                                        },
                                        [_vm._v(_vm._s(_vm.$t("bib.card.btn")))]
                                      ),
                                      _c("bib-modal")
                                    ],
                                    1
                                  ),
                                  _c(
                                    "b-card",
                                    {
                                      staticClass: "dashCard dashDisabled",
                                      attrs: {
                                        title: _vm.$t("raceday.card.head"),
                                        "img-src": "/public/images/rd.jpg",
                                        "img-alt": "Race Day",
                                        "img-top": ""
                                      }
                                    },
                                    [
                                      _c("b-card-text", [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t" +
                                            _vm._s(
                                              _vm.$t("raceday.card.desc")
                                            ) +
                                            "\n\t\t\t\t\t\t\t"
                                        )
                                      ]),
                                      _c(
                                        "b-button",
                                        {
                                          attrs: {
                                            href:
                                              "https://borobudurmarathon.com/race-day",
                                            block: "",
                                            variant: "primary"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("raceday.card.btn"))
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "b-row",
                        { staticClass: "dashRow" },
                        [
                          _vm.racepackReady
                            ? _c("b-col", { attrs: { md: "8" } }, [
                                _c(
                                  "div",
                                  { staticClass: "mainCard" },
                                  [
                                    _c(
                                      "b-card",
                                      {
                                        attrs: {
                                          "img-src": "/public/images/rpc.jpg",
                                          "img-alt": "Race Pack Collection",
                                          "img-top": ""
                                        }
                                      },
                                      [
                                        _c("h2", [
                                          _vm._v(
                                            _vm._s(_vm.$t("rpc.card.head"))
                                          )
                                        ]),
                                        _c("p", [
                                          _vm._v(
                                            _vm._s(_vm.$t("rpc.card.desc"))
                                          )
                                        ]),
                                        _c(
                                          "div",
                                          { staticClass: "rpcInfo" },
                                          [
                                            _c(
                                              "b-row",
                                              [
                                                _c("b-col", {
                                                  staticClass: "rpcSchedule",
                                                  attrs: { md: "7" },
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      _vm.$t("rpc.schedule")
                                                    )
                                                  }
                                                }),
                                                _c("b-col", {
                                                  attrs: { md: "5" },
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      _vm.$t("rpc.venue")
                                                    )
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "groupLabel" },
                                          [
                                            _c("label", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "rpc.instructions.label"
                                                  )
                                                )
                                              )
                                            ])
                                          ]
                                        ),
                                        _vm.ballotData
                                          ? _c(
                                              "b-row",
                                              {
                                                staticClass: "rpcInstructions"
                                              },
                                              [
                                                _c(
                                                  "b-col",
                                                  {
                                                    staticClass: "rpcQR",
                                                    attrs: { md: "auto" }
                                                  },
                                                  [
                                                    _c("svg-image", {
                                                      attrs: { image: "QR" }
                                                    }),
                                                    _c(
                                                      "h6",
                                                      {
                                                        staticStyle: {
                                                          color: "#aaa"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.ballotData
                                                              .mregOrderId
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _c("b-col", {
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      _vm.$t(
                                                        "rpc.instructions.point"
                                                      )
                                                    )
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _c(
                                          "b-button",
                                          {
                                            directives: [
                                              {
                                                name: "b-modal",
                                                rawName:
                                                  "v-b-modal.delegationModal",
                                                modifiers: {
                                                  delegationModal: true
                                                }
                                              }
                                            ],
                                            attrs: { variant: "primary" }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("rpc.instructions.btn")
                                              )
                                            )
                                          ]
                                        ),
                                        _c("delegation-modal"),
                                        _c(
                                          "div",
                                          { staticClass: "rpcDelegated" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "groupLabel" },
                                              [
                                                _c("label", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "rpc.delegation.label"
                                                      )
                                                    )
                                                  )
                                                ])
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "statusTransferred"
                                              },
                                              [
                                                _c(
                                                  "b-row",
                                                  { staticClass: "status" },
                                                  [
                                                    _c(
                                                      "b-col",
                                                      { attrs: { sm: "auto" } },
                                                      [
                                                        _c("svg-image", {
                                                          attrs: {
                                                            image:
                                                              "iconDelegated"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    ),
                                                    _c("b-col", [
                                                      _c("h6", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "rpc.delegation.statuslabel"
                                                            )
                                                          )
                                                        )
                                                      ]),
                                                      _c("p", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "rpc.delegation.statusdesc"
                                                            )
                                                          )
                                                        )
                                                      ])
                                                    ])
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            ),
                                            _c("table", [
                                              _c("tbody", [
                                                _c("tr", [
                                                  _c(
                                                    "td",
                                                    { staticClass: "heady" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "rpc.delegation.rname"
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _c("td", [
                                                    _vm._v("Pengambil Respek")
                                                  ])
                                                ]),
                                                _c("tr", [
                                                  _c(
                                                    "td",
                                                    { staticClass: "heady" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "rpc.delegation.remail"
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _c("td", [
                                                    _vm._v(
                                                      "pengambil@respek.com"
                                                    )
                                                  ])
                                                ]),
                                                _c("tr", [
                                                  _c(
                                                    "td",
                                                    { staticClass: "heady" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "rpc.delegation.rphone"
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _c("td", [
                                                    _vm._v("08123456789")
                                                  ])
                                                ])
                                              ])
                                            ])
                                          ]
                                        ),
                                        _c(
                                          "b-button",
                                          { attrs: { variant: "primary" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("rpc.delegation.cancel")
                                              )
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ])
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/views/HomeView.vue?vue&type=template&id=9ea40744&
// module id = 872
// module chunks = 0